const ACTIVE_SVG_CONTENT = /<\s*(script|style|foreignobject|iframe|object|embed|audio|video|image|use|a)\b/i;
const EVENT_HANDLER_ATTRIBUTE = /\son[a-z]+\s*=/i;
const SCRIPT_URL = /\b(?:href|xlink:href|src)\s*=\s*(['"]?)\s*(javascript:|data:|https?:|\/\/)/i;
const INLINE_STYLE_ATTRIBUTE = /\sstyle\s*=/i;

function decodeNumericEntities(value: string): string {
  return value
    .replace(/&#x([0-9a-f]+);?/gi, (_match, code: string) => String.fromCodePoint(Number.parseInt(code, 16)))
    .replace(/&#([0-9]+);?/g, (_match, code: string) => String.fromCodePoint(Number.parseInt(code, 10)))
    .replace(/&colon;?/gi, ':');
}

export function isSafeInlineSvg(value: string | undefined): value is string {
  if (!value) return false;
  const trimmed = value.trim();
  const normalized = decodeNumericEntities(trimmed);

  return (
    normalized.toLowerCase().startsWith('<svg') &&
    !ACTIVE_SVG_CONTENT.test(normalized) &&
    !EVENT_HANDLER_ATTRIBUTE.test(normalized) &&
    !SCRIPT_URL.test(normalized) &&
    !INLINE_STYLE_ATTRIBUTE.test(normalized)
  );
}
